<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { InputPrimary } from '@shared/ui/fields'

import { useFiltersEntityChangelog } from '../model/filters-entity-changelog.hook'

defineOptions({
  name: 'FiltersEntityChangelog',
})

const {
  refSearch,
  refDateRange,
  isLoading,
  setSearch,
  handleSearch,
  handleClear,
} = useFiltersEntityChangelog()
</script>

<template>
  <FiltersBar
    class="filters-entity-changelog"
    :loading="isLoading"
    @click:submit="handleSearch"
    @click:clear="handleClear"
  >
    <template #fields>
      <InputPrimary
        id="entity-changelog-search"
        class="filters-entity-changelog__search"
        label="Search"
        type="text"
        placeholder="Search"
        :value="refSearch"
        :disabled="isLoading"
        @update:value="setSearch"
      />

      <FilterDateRange
        v-model="refDateRange"
        presets
        class="filters-entity-changelog__date"
        label="Date"
        placeholder="Search"
        :disabled="isLoading"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersEntityChangelog.scss" />
